import React from "react";
import "./C2Page.css";
import C2CourseDetails from "./C2CourseDetails";

const C2Main = () => {
  return (
    <div className="c1PageMainContainer">
      <C2CourseDetails />
    </div>
  );
};

export default C2Main;
